var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"container",staticClass:"container",style:({ 'background-color': _vm.on ? '#b0d255' : '#babcbe' }),on:{"click":function($event){return _vm.$emit('input', !_vm.on)}}},[_c('div',{staticClass:"ball",style:({ left: _vm.getLeft })},[_c('img',{attrs:{"src":require("../assets/images/kocka.png"),"alt":""}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }